/**
 * NOTES:
 *
 * Minifier doesn't like const
 *
 */
angular.module('app', ['ui.router'])
.constant('BUILD', {
    url: 'aifb_build_version'.toUpperCase() != '1762654586789' ? '1762654586789' + '/' : ''
})
.config(['BUILD', '$locationProvider', '$stateProvider', '$urlRouterProvider', function(BUILD, $locationProvider, $stateProvider, $urlRouterProvider) {
    // A base tag will be included for root deployments
    if($('base').length) {
        $locationProvider
        .html5Mode({
            // Uses HTML5 history.pushState; falls back to #! where not supported
            enabled: true,
            // Prevents treating links to documents as states
            rewriteLinks: false
        })
        .hashPrefix('!');
    }

    var templateUrl = function(url) {
        return BUILD.url ? BUILD.url + url : url;
    };

    $urlRouterProvider.otherwise('/');
    $stateProvider
    /**
     * Defines a view with nav and footer with content sandwiched between.
     */
    .state('root', {
        abstract: true,
        templateUrl: templateUrl('view/root.html'),
        controller: 'RootController'
    })
    /**
     * Overrides the root view for current exhibition nav/footer styling.
     * Reuses the RootController for the state and navigation foundation it builds.
     */
    .state('override-root', {
        abstract: true,
        templateUrl: templateUrl('view/override-root.html'),
        controller: 'RootController'
    })
    .state('splash-root', {
        abstract: true,
        templateUrl: templateUrl('view/splash-root.html'),
        controller: 'RootController'
    })
    /**
     * Builds a header and tagline beneath nav, above content.
     * SiteController updates the rootScope properties that dictate body styling.
     */
    .state('site', {
        parent: 'root',
        abstract: true,
        templateUrl: templateUrl('view/site.html'),
        controller: 'SiteController'
    })
    /**
     * Takes the place of the site state, building an exhibition-specific header above the content.
     * OverrideController updates the rootScope properties that dictate body styling.
     */
    .state('override', {
        parent: 'override-root',
        abstract: true,
        templateUrl: templateUrl('view/override.html'),
        controller: 'OverrideController'
    })
    /**
     * A state between override root and the content which does not include a header.
     * SplashController updates the rootScope properties that dictate body styling.
     * Uses the override body styling too.
     */
    .state('splash', {
        // Changed to splash-root from override-root just to mess with the footer
        parent: 'splash-root',
        abstract: true,
        templateUrl: templateUrl('view/splash.html'),
        controller: 'SplashController'
    })
    .state('error', {
        parent: 'site',
        url: '/error',
        templateUrl: templateUrl('view/error.html'),
    })
    /* Temporarily taken over by splash home during exhibition time.
     * When no exhibition is running, this is the homepage.
     * See steps in splash home below for exhibition override.
    .state('home', {
        parent: 'site',
        url: '/',
        templateUrl: templateUrl('view/home.html'),
        onEnter: ['PageTitle', function(PageTitle) {
            PageTitle.set('Home');
        }],
        controller: 'HomeController'
    })
     */
    /**
     * Temporarily takes over the home state.
     * Replaces the home content with splash-specific home content.
     * SplashHomeController loads only data necessary for the splash content.
     *
     * To enable exhibition mode, comment out the 'home' state with 'site' parent
     * and comment in this one with 'splash' parent.
     */
    .state('home', {
        parent: 'splash',
        url: '/',
        templateUrl: templateUrl('view/splash-home.html'),
        onEnter: ['PageTitle', function(PageTitle) {
            PageTitle.set('Home');
        }],
        controller: 'SplashHomeController'
    })
    /**
     * Generically handles directory nodes in the site by assuming an index.html
     * is present for each top-level subdirectory.
     */
    .state('section', {
        parent: 'site',
        url: '/:section',
        templateUrl: function($stateParams) {
            return templateUrl('view/' + $stateParams.section + '/index.html');
        },
        onEnter: ['$stateParams', 'PageTitle', function($stateParams, PageTitle) {
            PageTitle.set(_.upperFirst($stateParams.section || ''));
        }]
    })
    /**
     * Generically handles individual nodes in top-level directories off the the
     * main page.  Treats the last portion of the path as the base-name for an
     * HTML file in the directory.
     */
    .state('page', {
        parent: 'site',
        url: '/:section/:id',
        templateUrl: function($stateParams) {
            return templateUrl('view/' + $stateParams.section + '/' + ($stateParams.id || 'index') + '.html');
        },
        onEnter: ['$stateParams', 'PageTitle', function($stateParams, PageTitle) {
            PageTitle.set(_.upperFirst($stateParams.section || ''));
        }]
    })
    .state('permanent', {
        parent: 'site',
        url: '/permanent',
        templateUrl: templateUrl('view/permanent/index.html'),
        onEnter: ['PageTitle', function(PageTitle) {
            PageTitle.set('Permanent Works');
        }],
        controller: 'PermanentController'
    })
    .state('photo', {
        parent: 'site',
        url: '/photo/:album',
        templateUrl: templateUrl('view/photo/index.html'),
        controller: ['$scope', '$stateParams', 'Album',
            function($scope, $stateParams, Album) {
            $scope.photos = Album.query({ year: $stateParams.album });
        }]
    })
    .state('news', {
        parent: 'site',
        url: '/news',
        templateUrl: templateUrl('view/news/index.html'),
        onEnter: ['PageTitle', function(PageTitle) {
            PageTitle.set('News');
        }],
        controller: 'NewsController'
    })
    .state('newsIndex', {
        parent: 'site',
        url: '/news/',
        data: {
            redirect: 'news'
        },
        controller: 'RedirectController'
    })
    .state('exhibitions', {
        parent: 'site',
        url: '/exhibition',
        templateUrl: templateUrl('view/exhibition/index.html'),
        onEnter: ['PageTitle', function(PageTitle) {
            PageTitle.set('Exhibitions');
        }],
        controller: 'ExhibitionsController'
    })
    .state('exhibitionsIndex', {
        parent: 'site',
        url: '/exhibition/',
        data: {
            redirect: 'exhibitions'
        },
        controller: 'RedirectController'
    })
    .state('exhibition', {
        parent: 'site',
        url: '/exhibition/:year',
        templateUrl: function($stateParams) {
            return templateUrl('view/exhibition/' + $stateParams.year + '/index.html');
        },
        onEnter: ['$stateParams', 'PageTitle', function($stateParams, PageTitle) {
            PageTitle.set(($stateParams.year ? $stateParams.year + ' ' : '') + 'Exhibition');
        }],
        controller: 'ExhibitionController'
    })
    .state('artists', {
        parent: 'site',
        url: '/artist',
        templateUrl: templateUrl('view/artist/index.html'),
        onEnter: ['PageTitle', function(PageTitle) {
            PageTitle.set('Artists');
        }],
        controller: 'ArtistsController'
    })
    .state('artistsIndex', {
        parent: 'site',
        url: '/artist/',
        data: {
            redirect: 'artists'
        },
        controller: 'RedirectController'
    })
    .state('artist', {
        parent: 'site',
        url: '/artist/:id',
        templateUrl: function($stateParams) {
            return templateUrl('view/artist/' + $stateParams.id + '.html');
        },
        onEnter: ['$stateParams', 'Work', 'PageTitle', function($stateParams, Work, PageTitle) {
            var artist = _.chain(Work.query({ id: $stateParams.id }))
            .map('artist')
            .first()
            .value();
            PageTitle.set('Artist' + (artist ? ': ' + artist : ''));
        }],
        controller: 'ArtistController'
    })
    .state('press-release', {
        parent: 'root',
        url: '/press-release/:id',
        templateUrl: function($stateParams) {
            return templateUrl('view/press/' + $stateParams.id + '.html');
        },
        onEnter: ['PageTitle', function(PageTitle) {
            PageTitle.set('Press Release');
        }]
    })
    .state('contact', {
        parent: 'site',
        url: '/contact',
        templateUrl: templateUrl('view/contact/index.html'),
        controller: 'ContactController'
    })
    .state('pressKit', {
        // Override parent from site to get exhibtion styling
        parent: 'override',
        url: '/press-kit',
        templateUrl: templateUrl('view/press-kit/index.html'),
        onEnter: ['PageTitle', function(PageTitle) {
            PageTitle.set('Press Kit');
        }],
        controller: 'PressKitController'
    })
    .state('pressKitIndex', {
        parent: 'site',
        url: '/press-kit/',
        data: {
            redirect: 'pressKit'
        },
        controller: 'RedirectController'
    })
    .state('about', {
        parent: 'site',
        url: '/about',
        templateUrl: templateUrl('view/about/index.html'),
        onEnter: ['PageTitle', function(PageTitle) {
            PageTitle.set('About');
        }],
        controller: 'AboutController'
    })
    .state('aboutIndex', {
        parent: 'site',
        url: '/about/',
        data: {
            redirect: 'about'
        },
        controller: 'RedirectController'
    })
    /**
     * Uses the style for the current exhibition, provides details.
     * Separate from the standard exhibition state, which records details for past exhibitions.
     */
    .state('current', {
        parent: 'override',
        url: '/current',
        templateUrl: templateUrl('view/current/index.html'),
        onEnter: ['Exhibition', 'PageTitle', function(Exhibition, PageTitle) {
            var exhibition = Exhibition.current();
            PageTitle.set((exhibition && exhibition.year ? exhibition.year + ' ' : '') + 'Exhibition');
        }],
        controller: 'CurrentController'
    })
    .state('currentIndex', {
        parent: 'site',
        url: '/current/',
        data: {
            redirect: 'current'
        },
        controller: 'RedirectController'
    })
    .state('currentTeam', {
        parent: 'override',
        url: '/current/team/:id',
        templateUrl: function($stateParams) {
            return templateUrl('view/current/team/' + $stateParams.id + '.html');
        },
        onEnter: ['$stateParams', 'Exhibition', 'PageTitle', function($stateParams, Exhibition, PageTitle) {
            //PageTitle.set(_.upperFirst($stateParams.id || ''));
            var exhibition = Exhibition.current();
            PageTitle.set((exhibition && exhibition.year ? exhibition.year + ' ' : '') + 'Exhibition Team');
        }]
    })
    // Not quite baked yet -- handles returning artists in current exhibition
    .state('currentArtist', {
        parent: 'override',
        url: '/current/artist/:id',
        templateUrl: templateUrl('view/current/artist/base.html'),
        /*
        templateUrl: function($stateParams) {
            return templateUrl('view/current/artist/' + $stateParams.id + '.html');
        },
        */
        onEnter: ['$stateParams', 'Work', 'PageTitle', function($stateParams, Work, PageTitle) {
            var artist = _.chain(Work.query({ id: $stateParams.id }))
            .map('artist')
            .first()
            .value();
            PageTitle.set('Artist' + (artist ? ': ' + artist : ''));
        }],
        controller: 'CurrentArtistController'
    })
    /**
     * The tour screen showing the map and list of works that can be visited.
     */
    .state('currentWorks', {
        parent: 'override',
        url: '/current/works',
        templateUrl: templateUrl('view/current/works/index.html'),
        controller: 'CurrentWorksController'
    })
    .state('currentWorksIndex', {
        parent: 'override',
        url: '/current/works/',
        data: {
            redirect: 'currentWorks'
        },
        controller: 'RedirectController'
    })
    /**
     * Shows the details for the indicated numeric work.
     * Includes links to previous and next works.
     */
    .state('currentWork', {
        parent: 'override',
        url: '/current/works/:id',
        /* This is a nice idea, but doesn't currently support collectives... */
        /*
        templateUrl: templateUrl('view/current/works/base.html'),
        */
        /*
        templateUrl: function($stateParams) {
            return templateUrl('view/current/works/' + $stateParams.id + '.html');
        },
        */
        /* A generic approach */
        templateUrl: templateUrl('view/current/works/standard.html'),
        controller: 'CurrentWorkController'
    })
    .state('twilight', {
        parent: 'override',
        url: '/current/twilight',
        templateUrl: templateUrl('view/current/twilight.html')
    });
}])
.controller('RootController', ['$rootScope', '$scope', '$state', '$transitions', '$window', '$filter', 'BUILD', 'PageTitle', 'Banner', 'Exhibition', function($rootScope, $scope, $state, $transitions, $window, $filter, BUILD, PageTitle, Banner, Exhibition) {
    // Copyright support
    $scope.now = new Date();

    // Where our assets live for this build
    $rootScope.buildUrl = BUILD.url;

    // Get the list of previous exhibitions for the menu
    $scope.exhibitions = _.chain(Exhibition.query())
    .reject('current')
    .reject('future')
    .reject('soon')
    .value();

    // If we have a current exhibition, make it available
    $scope.currentExhibition = Exhibition.current();

    // Pick a random banner
    var setBanner = function() {
        // Skip if we're on a page that won't use the image
        // TODO: Find a way to avoid always loading at least one banner
        if($scope.banner && ($rootScope.override || $rootScope.splash)) {
            return;
        }

        var banner = Banner.random();
        var image = new Image();
        image.onload = function() {
            $scope.$apply(function() {
                $scope.banner = banner;
            });
        };
        image.src = banner.url;
    };
    setBanner();

    // Reset the banner on transition between states
    $transitions.onCreate({ }, _.throttle(setBanner, 200));

    // Set the page title
    var setTitle = function() {
        var pageTitle = PageTitle.get();
        var value = 'Arts in Foggy Bottom' + (pageTitle ? ' - ' + pageTitle : '');
        $window.document.title = value;
    };
    $transitions.onEnter({ }, _.debounce(setTitle, 100));

    // Scroll to the top of the page
    var scrollTop = function() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };
    $transitions.onEnter({ }, _.throttle(scrollTop, 200));

    // Watch for a menu
    var setMobile = function() {
        return $scope.mobile = $('button.navbar-toggle').is(':visible');
    };
    setMobile();

    $(window).on('resize', _.debounce(function() {
        $scope.$apply(setMobile);
    }, 100));
}])
.controller('SiteController', ['$scope', '$rootScope', function($scope, $rootScope) {
    $rootScope.bodyStyle = undefined;
    $rootScope.override = false;
    $rootScope.splash = false;
}])
.controller('SplashController', ['$scope', '$rootScope', 'Exhibition', function($scope, $rootScope, Exhibition) {
    var current = Exhibition.current();
    $scope.exhibition = current;
    /* Disabled for 2025 thanks to a simple gradient we can do with CSS
    $rootScope.bodyStyle = {
        'background-size': '100%',
        'background-repeat': 'no-repeat',
        'background-image': 'url("' + $scope.buildUrl + 'images/exhibition/' + current.year + '/background.jpg")'
    };
    */
    $rootScope.override = true;
    $rootScope.splash = true;
}])
.controller('OverrideController', ['$scope', '$rootScope', 'Exhibition', function($scope, $rootScope, Exhibition) {
    var current = Exhibition.current();
    $scope.exhibition = current;
    /* Disabled for 2025 thanks to a simple gradient we can do with CSS
    $rootScope.bodyStyle = {
        'background-size': '100%',
        'background-repeat': 'no-repeat',
        'background-image': 'url("' + $scope.buildUrl + 'images/exhibition/' + current.year + '/background.jpg")'
    };
    */
    $rootScope.override = true;
    $rootScope.splash = false;
}])
.controller('SplashHomeController', ['$scope', '$timeout', 'Exhibition', 'Work', 'Video', function($scope, $timeout, Exhibition, Work, Video) {
    var exhibition = Exhibition.current();
    var works = Work.query({ year: exhibition.year });

    // TODO May be inheritable from the parent controller
    $scope.exhibition = exhibition;

    $scope.artists = _.chain(works)
    .uniqBy('id')
    .map(function(w) {
        return {
            id: w.id,
            name: w.artist,
            work: _.chain(works).filter({ id: w.id }).map('name').join(' and ').value()
        };
    })
    .value();

    const endHandler = function(event) {
        // NOOP
        //$scope.play('Curator Exhibition');
    };

    // Video stuff
    // Temporarily duplicated
    $scope.play = function(name) {
        // Find the video, construct source location
        var video = Video.play(name, $scope.exhibition.videos, function(v, video) {
            return {
                type: v.type,
                src: '/assets/exhibition/' + $scope.exhibition.year + '/videos/' + video.id + '/' + v.file
            };
        });

        if( ! (video && video.video && _.size(video.sources))) {
            return;
        }

        $scope.sources = video.sources;
        $scope.video = video.video;

        // Set a timeout to scroll the element into view
        $timeout(function() {
            _.forEach($('video'), function(v) {
                v.scrollIntoView({ behavior: 'smooth' });

                if(name == 'Curator Interview') {
                    v.addEventListener('ended', endHandler);
                }
                else {
                    v.removeEventListener('ended', endHandler);
                    v.play();
                }

                return false;
            });
        }, 500);
    };

    $scope.sources = [ ];

}])
.controller('HomeController', ['$scope', 'Work', function($scope, Work) {
    var works = _.chain(Work.query())
    .filter(function(w) {
        // Exhibitions, inherited from the root controller have already been filtered to past only
        return w && w.year > 2012 && _.find($scope.exhibitions, { year: w.year });
    })
    .value();

    $scope.work = works[_.random(_.size(works) - 1)];
    var photo = _.get($scope, 'work.photo.square');
    if(photo) {
        $scope.photo = $scope.work.order + '/' + photo;
    }
    else {
        $scope.photo = $scope.work.image;
    }
}])
.controller('NewsController', ['$scope', 'News', function($scope, News) {
    $scope.news = News.query();
}])
.controller('ExhibitionsController', ['$scope', 'Exhibition', function($scope, Exhibition) {
    $scope.exhibitions = Exhibition.query();
}])
.controller('ExhibitionController', ['$scope', '$interval', '$stateParams', 'Exhibition', 'Work', 'Video', function($scope, $interval, $stateParams, Exhibition, Work, Video) {
    var exhibition = _.head(Exhibition.query({ year: $stateParams.year }));
    var works = Work.query({ year: $stateParams.year });

    $scope.exhibition = exhibition;
    $scope.year = $stateParams.year;
    $scope.works = works;
    $scope.artists = _.chain(works)
    .uniqBy('id')
    .map(function(w) {
        return {
            id: w.id,
            name: w.artist,
            work: _.chain(works).filter({ id: w.id }).map('name').join(' and ').value()
        };
    })
    .value();

    $scope.artistCount = _.chain($scope.artists)
    .map('name')
    .map(_.toLower)
    .map(function(a) {
        return a && a.split(' and ');
    })
    .flatten()
    .uniq()
    .size();

    var workLen = _.size(works);
    var workIdx = _.random(workLen - 1);

    var nextWork = function() {
        workIdx = workIdx == workLen - 1 ? 0 : workIdx + 1;
        $scope.work = works[workIdx];
        var photo = _.get($scope, 'work.photo.square');
        if(photo) {
            $scope.photo = $scope.work.order + '/' + photo;
        }
        else {
            $scope.photo = $scope.work.image;
        }
    };

    var promise = $interval(nextWork, 5000);

    nextWork();

    $scope.$on('$destroy', function() {
        if(promise) {
            $interval.cancel(promise);
        }
    });

    // Video stuff
    // Temporarily duplicated
    $scope.play = function(name) {
        // Find the video, construct source location
        var video = Video.play(name, $scope.exhibition.videos, function(v, video) {
            return {
                type: v.type,
                src: '/assets/exhibition/' + $scope.exhibition.year + '/videos/' + video.id + '/' + v.file
            };
        });

        if(video && video.video && _.size(video.sources)) {
            $scope.sources = video.sources;
            $scope.video = video.video;
        }
    };
}])
.controller('ArtistsController', ['$scope', 'Work', 'Exhibition', function($scope, Work, Exhibition) {
    var works = Work.query();
    $scope.count = Work.artistCount();
    $scope.exhibitions = _.map(Exhibition.query(), function(ex) {
        var result = _.cloneDeep(ex);

        result.artists = _.chain(works)
        .filter({ year: ex.year })
        .uniqBy('id')
        .value();

        return result;
    });
}])
.controller('ArtistController', ['$scope', '$interval', '$stateParams', 'Work', 'Exhibition', 'Video', function($scope, $interval, $stateParams, Work, Exhibition, Video) {
    var allWorks = Work.query({ id: $stateParams.id });
    $scope.works = _.chain(allWorks)
    .map(function(work) {
        var result = _.clone(work);
        result.exhibition = _.chain(Exhibition.query({ year: work.year })).first().value();
        return result;
    })
    .filter('name')
    .reject({ exhibition: { future: true } })
    .reject({ exhibition: { soon: true } })
    .reject({ exhibition: { current: true } })
    .value();

    $scope.website = _.chain(allWorks).map('website').filter(_.identity).first().value();
    $scope.artist = _.chain(allWorks).map('artist').filter(_.identity).first().value();
    $scope.caption = _.chain(allWorks).map('caption').filter(_.identity).first().value();
    $scope.photo = _.chain($stateParams.id).split('-').map(_.capitalize).join('-').value();

    // Controller-specific video management
    $scope.play = function(work, video) {
        // Find the video, determine the appropriate variation, construct source location
        var video = Video.play(video.name, [ video ], function(v, video) {
            return {
                type: v.type,
                src: '/assets/exhibition/' + work.year + '/videos/' + work.id + '/' + v.file
            };
        });

        if(video && video.video && _.size(video.sources)) {
            $scope.sources = video.sources;
            $scope.currentVideo = video.video;
        }
    };

    $scope.sources = [ ];
}])
.controller('PermanentController', ['$scope', '$interval', 'Permanent', function($scope, $interval, Permanent) {
    $scope.works = Permanent.query();
    Permanent.init();

    var nextWork = function() {
        $scope.work = Permanent.next();
    };

    var promise = $interval(nextWork, 5000);

    nextWork();

    $scope.$on('$destroy', function() {
        if(promise) {
            $interval.cancel(promise);
        }
    });
}])
.controller('ContactController', ['$scope', '$http', function($scope, $http) {
    $scope.email = { };
    $scope.sendEmail = function() {
        $scope.sendDisabled = true;
        $scope.error = false;
        $http({
            method: 'POST',
            url: 'https://iv615y34a5.execute-api.us-east-1.amazonaws.com/prod/contact',
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                email: $scope.email
            }
        })
        .then(function(response) {
            var s = response && response.status;
            var d = response && response.data;
            if(s == 200 && d && d.message == 'Success') {
                $scope.sent = true;
                $scope.email = { };
            }
            else {
                $scope.error = true;
            }
        })
        .catch(function(response) {
            $scope.error = true;
        })
        .finally(function() {
            $scope.sendDisabled = false;
        });
    };
}])
.controller('PressKitController', ['$scope', 'Device', 'Exhibition', 'Work', function($scope, Device, Exhibition, Work) {
    $scope.toggles = { };
    const toggle = function(evt) {
        $scope.toggles[evt.target.id] = !$scope.toggles[evt.target.id];
        $scope.$apply();
    };
    $('.collapse').on('show.bs.collapse', toggle);
    $('.collapse').on('hide.bs.collapse', toggle);

    $scope.exhibition = _.find(Exhibition.query(), function(e) {
        return e && (e.current || e.soon);
    });
    $scope.works = Work.query({ year: $scope.exhibition && $scope.exhibition.year });
    $scope.photos = { };
    _.forEach($scope.works, function(w) {
        $scope.photos[w.order] = _.filter(w.photos, { press: true });
    });
}])
.controller('AboutController', ['$scope', 'Work', function($scope, Work) {
    $scope.artistCount = Work.artistCount();
}])
.controller('RedirectController', [ '$state', function($state) {
    var target = _.get($state, 'current.data.redirect') || 'home';
    $state.go(target);
}])
.controller('CurrentController', ['$scope', '$interval', '$timeout', 'BUILD', 'Exhibition', 'Work', 'Video', function($scope, $interval, $timeout, BUILD, Exhibition, Work, Video) {
    var exhibition = Exhibition.current();
    var works = Work.query({ year: exhibition.year });

    $scope.exhibition = exhibition;

    $scope.artists = _.chain(works)
    .uniqBy('id')
    .map(function(w) {
        return {
            id: w.id,
            name: w.artist,
            work: _.chain(works).filter({ id: w.id }).map('name').join(' and ').value()
        };
    })
    .value();

    // Start rotating the works
    var photos = _.chain(works)
    .map(function(w) {
        var res = [ ];
        for(var x = 0, z = _.size(w.photos); x < z; x++) {
            var p = w.photos[x];
            if(p.portrait) {
                res.push({
                    work: w.order,
                    photo: p.id,
                    file: p.portrait
                });
            }
        }
        return res;
    })
    .flatten()
    .shuffle()
    .value();

    /* No photos yet
    var photoIdx = 0;
    var photoLen = _.size(photos);

    var nextPhoto = function(count) {
        photoIdx = photoIdx + 1 == photoLen ? 0 : photoIdx + 1;
        var photo = photos[photoIdx];

        // First invocation, just use the photo
        if(count < 1) {
            $scope.photo = photo;
            return;
        }

        // Subsequent invocations, preload the image before applying it
        var img = new Image();
        img.onload = function() {
            $scope.$apply(function() {
                $scope.photo = photo;
            });
        };
        img.src = BUILD.url + 'images/exhibition/' + exhibition.year +
            '/works/' + photo.work + '/' + photo.photo + '/' + photo.file + '.jpg';
    };

    var promise = $interval(nextPhoto, 10000);

    // Pre-interval invocation
    nextPhoto(0);

    $scope.$on('$destroy', function() {
        if(promise) {
            $interval.cancel(promise);
        }
    });
    */

    // Video stuff
    // Temporarily duplicated

    const endHandler = function(event) {
        // NOOP
        //$scope.play('Curator Exhibition');
    };

    $scope.play = function(name) {
        // Find the video, construct source location
        var video = Video.play(name, $scope.exhibition.videos, function(v, video) {
            return {
                type: v.type,
                src: '/assets/exhibition/' + $scope.exhibition.year + '/videos/' + video.id + '/' + v.file
            };
        });

        if(video && video.video && _.size(video.sources)) {
            $scope.sources = video.sources;
            $scope.video = video.video;
        }

        // Set a timeout to scroll the element into view
        $timeout(function() {
            _.forEach($('video'), function(v) {
                v.scrollIntoView({ behavior: 'smooth' });

                if(name == 'Curator Interview') {
                    v.addEventListener('ended', endHandler);
                }
                else {
                    v.removeEventListener('ended', endHandler);
                    v.play();
                }

                return false;
            });
        }, 500);
    };

    $scope.sources = [ ];
}])
.controller('CurrentArtistController', ['$scope', '$interval', '$stateParams', '$state', '$timeout', 'Work', 'Exhibition', 'Video', function($scope, $interval, $stateParams, $state, $timeout, Work, Exhibition, Video) {
    // Is the artist part of the current exhibition (assuming there is one)?
    var exhibition = Exhibition.current();
    var works = Work.query({ id: $stateParams.id, year: (exhibition && exhibition.year || 0) });

    // Any works in the current exhibition?
    if( ! _.size(works)) {
        // Go to the standard artist page
        $state.go('artist', { id: $stateParams.id });
        return;
    }

    // Determine next/previous artists if we're not at the beginning/end
    // Currently counts on the fact that works are ordered by artist last name
    var artists = _.uniqBy(Work.query({ year: exhibition.year }), 'id');
    var idx = _.findIndex(artists, { id: $stateParams.id });
    $scope.next = _.get(idx < _.size(artists) - 1 ? artists[idx + 1] : undefined, 'id');
    $scope.prev = _.get(idx > 0 ? artists[idx - 1] : undefined, 'id');

    // Collect the artist's works for this year
    $scope.works = _.chain(works)
    .filter({ year: exhibition.year })
    .filter('name')
    .map(function(work) {
        var result = _.clone(work);
        result.exhibition = _.head(Exhibition.query({ year: work.year }));
        return result;
    })
    .value();

    // Artist information
    $scope.id = _.chain(works).map('id').first().value();
    $scope.artist = _.chain(works).map('artist').first().value();
    $scope.caption = _.chain(works).map('caption').first().value();
    $scope.website = _.chain(works).map('website').first().value();
    $scope.photo =  _.chain($stateParams.id).split('-').map(_.capitalize).join('-').value();

    // Controller-specific video management
    $scope.play = function(work, video) {
        // Find the video, determine the appropriate variation, construct source location
        var video = Video.play(video.name, [ video ], function(v, video) {
            return {
                type: v.type,
                src: '/assets/exhibition/' + work.year + '/videos/' + work.id + '/' + v.file
            };
        });

        if( ! (video && video.video && _.size(video.sources))) {
            return;
        }

        $scope.sources = video.sources;
        $scope.currentVideo = video.video;

        // Set a timeout to scroll the element into view
        $timeout(function() {
            _.forEach($('video'), function(v) {
                v.scrollIntoView({ behavior: 'smooth' });
                return false;
            });
        }, 500);
    };

    $scope.sources = [ ];
}])
.controller('CurrentWorksController', [ '$rootScope', '$scope', 'Exhibition', 'Work', function($rootScope, $scope, Exhibition, Work) {
    $scope.exhibition = Exhibition.current();
    $scope.works = $scope.exhibition && _.sortBy(Work.query({ year: $scope.exhibition.year }), 'order');
}])
.controller('CurrentWorkController', [ '$rootScope', '$scope', '$stateParams', '$timeout', 'Work', 'Exhibition', 'Video', function($rootScope, $scope, $stateParams, $timeout, Work, Exhibition, Video) {
    // Standard stuff
    var id = parseInt($stateParams.id);
    $scope.exhibition = Exhibition.current();
    $scope.works = Work.query({ year: $scope.exhibition.year });
    $scope.work = _.find($scope.works, { order: id });
    $scope.next = _.find($scope.works, { order: id + 1 });
    $scope.prev = _.find($scope.works, { order: id - 1 });

    $scope.artist = {
        about: $scope.work.about
    };

    // Artist photo
    $scope.photo = $scope.work.noartistphoto ?
        undefined : _.chain($scope.work.id).split('-').map(_.capitalize).join('-').value();

    // Find the image and associated styling for the work photo
    _.forEach($scope.work.photos, function(val, idx) {
        if( ! (val && val.tour)) {
            return true;
        }

        $scope.image = {
            size: val.tour.size,
            position: val.tour.position,
            padding: val.tour.padding,
            url: $rootScope.buildUrl + 'images/exhibition/' + $scope.work.year +
                '/works/' + $scope.work.order + '/' + (idx + 1) + '/full.jpg'
        };

        return false;
    });

    // Videos available
    $scope.workVideo = _.find($scope.work.videos, { name: 'Work' });
    $scope.processVideo = _.find($scope.work.videos, { name: 'Process' });
    $scope.interviewVideo = _.find($scope.work.videos, { name: 'Interview' });

    // Video stuff
    // Temporarily duplicated
    $scope.play = function(name) {
        // Find the video or bail
        var video = Video.play(name, $scope.work.videos, function(v, video) {
            return {
                type: v.type,
                src: '/assets/exhibition/' + $scope.exhibition.year + '/videos/' + $scope.work.id + '/' + v.file
            };
        });

        if(video && video.video && _.size(video.sources)) {
            $scope.sources = video.sources;
            $scope.video = video.video;
        }

        // Set a timeout to scroll the element into view
        $timeout(function() {
            _.forEach($('video'), function(v) {
                v.scrollIntoView({ behavior: 'smooth' });
                return false;
            });
        }, 500);
    };

    $scope.sources = [ ];
    
}])
.run(['$rootScope', function($rootScope) {
    // Make lodash available to the scope
    $rootScope._ = _;
}]);
